<template>
  <b-container>

    <modal-payment @close="showModal = false" :show="showModal" title="Processing payment..."></modal-payment >

    <b-row align-h="center" class="mt-5">

      <b-col cols="12" class="mb-5">
        <b-card-header class="card-main-header">
          <h3 class="text-center">Details</h3>
        </b-card-header>
        <b-card-group>

          <b-card class="card-main p-3 text-center">

            <b-card-text><h4>Your Plan:</h4></b-card-text>
            <h4 class="font-weight-light">{{ plan.name }}</h4>

          </b-card>


          <b-card class="card-main p-3 text-center">

            <b-card-text>
              <h4 v-if="!isCashButtonHidden">Choose the amount:</h4>
              <h4 v-else>Amount:</h4>
            </b-card-text>
            <h4 class="font-weight-light">
              <small class="dollar">$</small>
              <template v-if="!isCashButtonHidden">
                <b-form-input class="text-center input-dark" v-model="donationAmount" lazy-formatter :formatter="donationAmountFormatter"></b-form-input>
              </template>
              <template v-else>
                {{ donationAmount }}
              </template>
            </h4>

          </b-card>

          <b-card class="card-main p-3 text-center">

            <b-card-text><h4>Time:</h4></b-card-text>
            <h4 class="font-weight-light">{{ plan.days == 0 ? 'Permanent' : donationTime + ' days' }}</h4>

          </b-card>

        </b-card-group>
      </b-col>

      <b-col md="7" sm="12" class="mb-5">
        <b-card-header class="card-main-header">
          <h3 class="text-center">Terms of Service</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <b-card-text><h4>By donating you agree to the following terms:</h4></b-card-text>

          <ul class="text-left">
            <li class="pb-3" v-for="term in terms" v-bind:key="term.id">
              {{ term.term }}
            </li>
          </ul>

        </b-card>
      </b-col>

      <b-col md="5" sm="12">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Donate!</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <b-card-text>Payment Methods:</b-card-text>
          <button v-if="!isCashButtonHidden" class="btn btn-lg btn-block btn-primary mb-3" v-on:click="loadPayPal()">Donate with Cash!</button>
          <div ref="paypal"></div>

          <b-card-text>Pay with Keys:</b-card-text>
          <a :href="tradeOfferURL" target="_blank" class="btn btn-lg btn-block btn-primary">Donate with Keys!</a>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UserApi from '@/services/UserApi'
import PlanApi from '@/services/PlanApi'
import router from "@/router"

// Vuex
import store from '../store'

// Event Bus
import EventBus from '@/services/EventBus'

const ModalPayment = () => import(
  './Modals/Payment.vue'
);

export default {
  props: {
    plan_id: {
      type: String,
      default: 0
    }
  },
  components: {
    ModalPayment
  },
  async created() {
    try {
      this.plan = await PlanApi.getPlan(this.plan_id);
      this.donationAmount = this.plan.amount;
    } catch (error) {
      EventBus.$emit('Error', error);
    }
  },
  methods: {
    loadPayPal: function() {
      this.isCashButtonHidden = true;

      const script = document.createElement('script');
      script.src = 'https://www.paypal.com/sdk/js?client-id=' + process.env.PAYPAL_LIVE_KEY;
      script.addEventListener('load', this.createPayPalButton);
      document.body.appendChild(script);
    },
    createPayPalButton: function() {
      window.paypal.Buttons({
        style: {
          color: 'black',
        },

        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              description: process.env.DONATION_DESCRIPTION,

              amount: {
                currency_code: process.env.DONATION_CURRENCY,
                value: this.donationAmount
              },
            }],

            application_context: {
              shipping_preference: 'NO_SHIPPING'
            }
          })
        },
        onApprove: async(data, actions) => {

          this.showModal = true;

          try {
            const details = await actions.order.capture();
            this.plan = await this.addDonator(data.orderID, this.plan.plan_id);
          } catch (error) {
            this.showModal = false;
            EventBus.$emit('Error', error);
          }
        },
        onError: error => {
          EventBus.$emit('Error', error);
        }
      })
      .render(this.$refs.paypal)
    },

    addDonator: async function(orderID, planID) {
      try {
        this.response = await UserApi.addDonator(orderID, planID);
        store.commit('user/setPaymentSuccess', true);
        this.$router.push({ name: 'success' });
      } catch (error) {
        EventBus.$emit('Error', error);
      }
    },

    donationAmountFormatter(value) {
      if(value.match(/^\d+(\.\d{1,2})?$/)) {
        return value < this.plan.amount ? this.plan.amount : value;
      } else {
        return this.plan.amount;
      }
    }
  },
  data() {
    return {
      tradeOfferURL: process.env.DONATION_KEY_LINK,
      showModal: false,
      plan: [],
      isCashButtonHidden: false,
      donationAmount: 0,
      terms: [
        { id: 1, term: 'No refund will be provided' },
        { id: 2, term: 'Abuse of commands will result in a cancellation of your perks without a refund or notice' },
        { id: 3, term: 'Any updates to perks after your donation will be applied to your rank' },
        { id: 4, term: 'Instigating a PayPal chargeback will result in a permanent ban' },
        { id: 5, term: 'You agree that you are receiving the perks as a form of appreciation for the donation' },
      ]
    }
  },
  computed: {
    donationTime() {
      return Math.ceil(this.plan.days / this.plan.amount * this.donationAmount);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Donate.vue